import Vue from 'vue'
import App from './App.vue'
import router from './router'
import mixins from '@/utils/mixins.js'
import store from "@/store/index.js";
import ErrorHandler from '@/utils/ErrorHandler.js'


// window.onerror = function(msg, src) {
//     new ErrorHandler(msg, src)
//     return;
// }

// Vue.config.errorHandler = function(err, vm, info) {
//     new ErrorHandler(err, 'VUE', info, vm)
// }

Vue.mixin(mixins)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
